var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card-toolbar',{attrs:{"icon":"highlight_off","title":"404"}}),_c('v-row',{staticClass:"pa-4"},[_c('h1',[_vm._v(_vm._s(_vm.$tc('not_implemented')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }